export const LEQ_updateAckScreenDetailsReducer = {
  LEQ_updateAckScreenDetails: (state, action) => {
    state.ackScreenDetails = { ...action.payload };
  },
};
